<template>
    <div class="main_container">
      <div class=" container-fluid edit-story-wrapper">
        <div id="controls-sidebar" class="controls-sidebar">
          <ul>
            <div @click="toggleSidebar" id="toggle-sidebar" class="toggle-sidebar">
              <svg id="toggle-sidebar-SVG" width="24" height="24" viewBox="0 0 47 78" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="7" y1="37.5268" x2="39.5269" y2="4.99992" stroke="white" stroke-width="10" stroke-linecap="round"/>
              <line x1="5" y1="-5" x2="51" y2="-5" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 39.5979 77.5979)" stroke="white" stroke-width="10" stroke-linecap="round"/>
              </svg>
            </div>
            <li  @click="addNode('Scene')">
              <span class="nav-link">
                  <img :src="addScene"/>
                  Add new scene
                </span>
            </li>
            <li  @click="addNode('Logic')">
              <span class="nav-link">
                  <img :src="addLogic"/>
                Add new logic
                </span>
            </li>
            <li  @click="addNode('Page')">
              <span class="nav-link">
                  <img :src="addPage"/>
                Add new page
                </span>
            </li>
            <li  @click="createGroup('New Group')">
              <span class="nav-link">
                <svg width="35" height="35" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#E4C1F9"/>
                  <path d="M13.23 9.54105H10.459V6.77005C10.459 6.64818 10.4106 6.5313 10.3245 6.44513C10.2383 6.35896 10.1214 6.31055 9.99955 6.31055C9.87768 6.31055 9.7608 6.35896 9.67463 6.44513C9.58846 6.5313 9.54005 6.64818 9.54005 6.77005V9.54105H6.77005C6.64818 9.54105 6.5313 9.58946 6.44513 9.67563C6.35896 9.7618 6.31055 9.87868 6.31055 10.0005C6.31055 10.1224 6.35896 10.2393 6.44513 10.3255C6.5313 10.4116 6.64818 10.46 6.77005 10.46H9.54105V13.231C9.54105 13.3529 9.58946 13.4698 9.67563 13.556C9.7618 13.6421 9.87868 13.6905 10.0005 13.6905C10.1224 13.6905 10.2393 13.6421 10.3255 13.556C10.4116 13.4698 10.46 13.3529 10.46 13.231V10.459H13.231C13.3529 10.459 13.4698 10.4106 13.556 10.3245C13.6421 10.2383 13.6905 10.1214 13.6905 9.99955C13.6905 9.87768 13.6421 9.7608 13.556 9.67463C13.4698 9.58846 13.3529 9.54005 13.231 9.54005L13.23 9.54105Z" fill="#161E32"/>
                  </svg>
                New group
              </span>
            </li>
            <li  @click="addTransition('Transition')">
              <span class="nav-link">
                <svg width="35" height="35" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#85D2BD"/>
                <path d="M8.18136 14.1011C8.12036 14.0401 8.03763 14.0058 7.95136 14.0058C7.86509 14.0058 7.78236 14.0401 7.72136 14.1011C7.66036 14.1621 7.62609 14.2448 7.62609 14.3311C7.62609 14.4174 7.66036 14.5001 7.72136 14.5611L8.08936 14.9291H6.60036C6.13419 14.9288 5.68719 14.7435 5.35756 14.4139C5.02793 14.0842 4.84262 13.6373 4.84236 13.1711V12.0811C4.84236 11.995 4.80817 11.9125 4.74732 11.8516C4.68646 11.7908 4.60392 11.7566 4.51786 11.7566C4.4318 11.7566 4.34926 11.7908 4.2884 11.8516C4.22755 11.9125 4.19336 11.995 4.19336 12.0811V13.1711C4.19362 13.8094 4.4473 14.4215 4.89865 14.8728C5.34999 15.3241 5.96206 15.5778 6.60036 15.5781H8.09236L7.72436 15.9461C7.67868 15.9914 7.64753 16.0493 7.63488 16.1124C7.62223 16.1755 7.62865 16.2409 7.65332 16.3003C7.67799 16.3597 7.7198 16.4105 7.77341 16.446C7.82702 16.4816 7.89002 16.5004 7.95436 16.5001C8.04049 16.4997 8.12303 16.4656 8.18436 16.4051L9.10636 15.4831C9.1366 15.4529 9.16058 15.417 9.17695 15.3776C9.19332 15.3381 9.20174 15.2958 9.20174 15.2531C9.20174 15.2104 9.19332 15.168 9.17695 15.1286C9.16058 15.0891 9.1366 15.0533 9.10636 15.0231L8.18136 14.1011Z" fill="#161E32"/>
                <path d="M9.8708 4.27808H4.5408C4.45495 4.27834 4.37269 4.31256 4.31199 4.37326C4.25128 4.43397 4.21706 4.51623 4.2168 4.60208V9.93208C4.21785 10.0174 4.25241 10.0989 4.31303 10.159C4.37365 10.219 4.45546 10.2528 4.5408 10.2531H9.8708C9.95665 10.2528 10.0389 10.2186 10.0996 10.1579C10.1603 10.0972 10.1945 10.0149 10.1948 9.92908V4.60208C10.1948 4.51615 10.1607 4.43374 10.0999 4.37297C10.0391 4.31221 9.95673 4.27808 9.8708 4.27808ZM9.5468 9.60808H4.8658V4.92708H9.5468V9.60808Z" fill="#161E32"/>
                <path d="M13.989 5.19999H12.496L12.864 4.83199C12.9162 4.7694 12.943 4.6895 12.9391 4.6081C12.9351 4.52671 12.9007 4.44976 12.8427 4.39252C12.7847 4.33527 12.7074 4.30191 12.6259 4.29903C12.5445 4.29615 12.4649 4.32398 12.403 4.37699L11.484 5.29899C11.4538 5.32917 11.4298 5.36502 11.4135 5.40449C11.3971 5.44396 11.3887 5.48626 11.3887 5.52899C11.3887 5.57171 11.3971 5.61402 11.4135 5.65348C11.4298 5.69295 11.4538 5.7288 11.484 5.75899L12.406 6.68099C12.4671 6.74182 12.5498 6.77598 12.636 6.77599C12.7222 6.77555 12.8047 6.74145 12.8661 6.68099C12.8963 6.6508 12.9203 6.61495 12.9366 6.57548C12.953 6.53602 12.9614 6.49371 12.9614 6.45099C12.9614 6.40826 12.953 6.36596 12.9366 6.32649C12.9203 6.28702 12.8963 6.25117 12.8661 6.22099L12.498 5.85299H13.9911C14.4572 5.85325 14.9042 6.03855 15.2339 6.36819C15.5635 6.69782 15.7488 7.14482 15.7491 7.61099V8.70099C15.7491 8.78705 15.7832 8.86959 15.8441 8.93044C15.9049 8.9913 15.9875 9.02549 16.0735 9.02549C16.1596 9.02549 16.2422 8.9913 16.303 8.93044C16.3639 8.86959 16.398 8.78705 16.398 8.70099V7.60599C16.3967 6.96776 16.1424 6.3561 15.6908 5.90509C15.2393 5.45408 14.6273 5.20051 13.989 5.19999Z" fill="#161E32"/>
                <path d="M16.0506 15.8511C16.008 15.8509 15.9658 15.8593 15.9264 15.8755C15.8871 15.8917 15.8513 15.9156 15.8212 15.9457C15.7911 15.9758 15.7672 16.0116 15.751 16.0509C15.7347 16.0903 15.7264 16.1325 15.7266 16.1751C15.7273 16.2611 15.7614 16.3436 15.8216 16.4051C15.8826 16.4661 15.9653 16.5003 16.0516 16.5003C16.1378 16.5003 16.2206 16.4661 16.2816 16.4051C16.3426 16.3441 16.3768 16.2613 16.3768 16.1751C16.3768 16.0888 16.3426 16.0061 16.2816 15.9451C16.2194 15.8853 16.1368 15.8517 16.0506 15.8511Z" fill="#161E32"/>
                <path d="M14.7166 15.8511C14.6525 15.8511 14.5899 15.8701 14.5366 15.9057C14.4833 15.9413 14.4418 15.9919 14.4172 16.0511C14.3927 16.1103 14.3863 16.1754 14.3988 16.2383C14.4113 16.3011 14.4422 16.3589 14.4875 16.4042C14.5328 16.4495 14.5905 16.4804 14.6534 16.4929C14.7162 16.5054 14.7814 16.4989 14.8406 16.4744C14.8998 16.4499 14.9504 16.4084 14.986 16.3551C15.0216 16.3018 15.0406 16.2392 15.0406 16.1751C15.0403 16.0892 15.0061 16.007 14.9454 15.9463C14.8847 15.8856 14.8024 15.8513 14.7166 15.8511Z" fill="#161E32"/>
                <path d="M12.0506 15.8511C11.9865 15.8511 11.9238 15.8701 11.8706 15.9057C11.8173 15.9413 11.7758 15.9919 11.7512 16.0511C11.7267 16.1103 11.7203 16.1754 11.7328 16.2383C11.7453 16.3011 11.7762 16.3589 11.8215 16.4042C11.8668 16.4495 11.9245 16.4804 11.9874 16.4929C12.0502 16.5054 12.1154 16.4989 12.1746 16.4744C12.2338 16.4499 12.2844 16.4084 12.32 16.3551C12.3556 16.3018 12.3746 16.2392 12.3746 16.1751C12.3743 16.0892 12.3401 16.007 12.2794 15.9463C12.2187 15.8856 12.1364 15.8513 12.0506 15.8511Z" fill="#161E32"/>
                <path d="M13.3846 15.8511C13.3205 15.8511 13.2578 15.8701 13.2045 15.9057C13.1512 15.9413 13.1097 15.9919 13.0852 16.0511C13.0607 16.1103 13.0543 16.1754 13.0668 16.2383C13.0793 16.3011 13.1101 16.3589 13.1554 16.4042C13.2007 16.4495 13.2585 16.4804 13.3213 16.4929C13.3842 16.5054 13.4493 16.4989 13.5085 16.4744C13.5677 16.4499 13.6183 16.4084 13.6539 16.3551C13.6895 16.3018 13.7085 16.2392 13.7085 16.1751C13.7083 16.0892 13.674 16.007 13.6133 15.9463C13.5526 15.8856 13.4704 15.8513 13.3846 15.8511Z" fill="#161E32"/>
                <path d="M10.7205 15.8511C10.6779 15.8509 10.6357 15.8593 10.5963 15.8755C10.557 15.8917 10.5212 15.9156 10.4911 15.9457C10.461 15.9758 10.4371 16.0116 10.4209 16.0509C10.4046 16.0903 10.3964 16.1325 10.3965 16.1751C10.3972 16.2611 10.4313 16.3436 10.4915 16.4051C10.5527 16.4657 10.6353 16.4999 10.7215 16.5001C10.8076 16.4994 10.89 16.4654 10.9515 16.4051C11.0123 16.344 11.0464 16.2613 11.0464 16.1751C11.0464 16.0889 11.0123 16.0062 10.9515 15.9451C10.8896 15.885 10.8068 15.8513 10.7205 15.8511Z" fill="#161E32"/>
                <path d="M10.7205 14.5181C10.6564 14.5181 10.5938 14.5371 10.5405 14.5727C10.4872 14.6083 10.4457 14.6589 10.4211 14.7181C10.3966 14.7773 10.3902 14.8424 10.4027 14.9053C10.4152 14.9681 10.4461 15.0259 10.4914 15.0712C10.5367 15.1165 10.5944 15.1473 10.6573 15.1598C10.7201 15.1723 10.7853 15.1659 10.8445 15.1414C10.9037 15.1169 10.9543 15.0753 10.9899 15.0221C11.0255 14.9688 11.0445 14.9062 11.0445 14.8421C11.0442 14.7562 11.01 14.674 10.9493 14.6133C10.8886 14.5525 10.8063 14.5183 10.7205 14.5181Z" fill="#161E32"/>
                <path d="M10.7205 13.1851C10.6565 13.1851 10.5938 13.204 10.5406 13.2396C10.4873 13.2752 10.4458 13.3257 10.4213 13.3849C10.3967 13.444 10.3902 13.5091 10.4026 13.5719C10.4151 13.6347 10.4458 13.6925 10.491 13.7378C10.5362 13.7832 10.5939 13.8141 10.6567 13.8267C10.7194 13.8393 10.7846 13.8331 10.8438 13.8087C10.903 13.7843 10.9537 13.7429 10.9894 13.6898C11.0251 13.6366 11.0443 13.5741 11.0445 13.5101C11.0445 13.424 11.0104 13.3415 10.9496 13.2806C10.8889 13.2197 10.8065 13.1853 10.7205 13.1851Z" fill="#161E32"/>
                <path d="M10.7205 11.8521C10.6564 11.8521 10.5938 11.871 10.5405 11.9066C10.4872 11.9422 10.4457 11.9929 10.4211 12.0521C10.3966 12.1113 10.3902 12.1764 10.4027 12.2393C10.4152 12.3021 10.4461 12.3598 10.4914 12.4052C10.5367 12.4505 10.5944 12.4813 10.6573 12.4938C10.7201 12.5063 10.7853 12.4999 10.8445 12.4754C10.9037 12.4509 10.9543 12.4093 10.9899 12.356C11.0255 12.3028 11.0445 12.2401 11.0445 12.1761C11.0442 12.0902 11.01 12.0079 10.9493 11.9472C10.8886 11.8865 10.8063 11.8523 10.7205 11.8521Z" fill="#161E32"/>
                <path d="M10.721 10.521C10.6349 10.521 10.5524 10.5552 10.4915 10.616C10.4307 10.6769 10.3965 10.7594 10.3965 10.8455C10.3965 10.9316 10.4307 11.0141 10.4915 11.075C10.5524 11.1358 10.6349 11.17 10.721 11.17C10.8071 11.1693 10.8895 11.1353 10.951 11.075C11.0116 11.0138 11.0458 10.9312 11.046 10.845C11.0452 10.7589 11.0112 10.6765 10.951 10.615C10.8897 10.5545 10.8071 10.5207 10.721 10.521Z" fill="#161E32"/>
                <path d="M14.7166 10.521C14.6525 10.521 14.5899 10.54 14.5366 10.5756C14.4833 10.6112 14.4418 10.6618 14.4172 10.721C14.3927 10.7802 14.3863 10.8454 14.3988 10.9082C14.4113 10.9711 14.4422 11.0288 14.4875 11.0741C14.5328 11.1194 14.5905 11.1503 14.6534 11.1628C14.7162 11.1753 14.7814 11.1689 14.8406 11.1443C14.8998 11.1198 14.9504 11.0783 14.986 11.025C15.0216 10.9717 15.0406 10.9091 15.0406 10.845C15.0403 10.7591 15.0061 10.6769 14.9454 10.6162C14.8847 10.5555 14.8024 10.5213 14.7166 10.521Z" fill="#161E32"/>
                <path d="M13.3846 10.521C13.3205 10.521 13.2578 10.54 13.2045 10.5756C13.1512 10.6112 13.1097 10.6618 13.0852 10.721C13.0607 10.7802 13.0543 10.8454 13.0668 10.9082C13.0793 10.9711 13.1101 11.0288 13.1554 11.0741C13.2007 11.1194 13.2585 11.1503 13.3213 11.1628C13.3842 11.1753 13.4493 11.1689 13.5085 11.1443C13.5677 11.1198 13.6183 11.0783 13.6539 11.025C13.6895 10.9717 13.7085 10.9091 13.7085 10.845C13.7083 10.7591 13.674 10.6769 13.6133 10.6162C13.5526 10.5555 13.4704 10.5213 13.3846 10.521Z" fill="#161E32"/>
                <path d="M12.0506 10.521C11.9865 10.521 11.9238 10.54 11.8706 10.5756C11.8173 10.6112 11.7758 10.6618 11.7512 10.721C11.7267 10.7802 11.7203 10.8454 11.7328 10.9082C11.7453 10.9711 11.7762 11.0288 11.8215 11.0741C11.8668 11.1194 11.9245 11.1503 11.9874 11.1628C12.0502 11.1753 12.1154 11.1689 12.1746 11.1443C12.2338 11.1198 12.2844 11.0783 12.32 11.025C12.3556 10.9717 12.3746 10.9091 12.3746 10.845C12.3743 10.7591 12.3401 10.6769 12.2794 10.6162C12.2187 10.5555 12.1364 10.5213 12.0506 10.521Z" fill="#161E32"/>
                <path d="M16.0506 10.521C15.9862 10.5208 15.9233 10.5397 15.8697 10.5753C15.8161 10.611 15.7743 10.6617 15.7495 10.7212C15.7248 10.7806 15.7183 10.846 15.7308 10.9092C15.7433 10.9723 15.7743 11.0303 15.8198 11.0758C15.8653 11.1213 15.9233 11.1523 15.9865 11.1648C16.0496 11.1773 16.115 11.1708 16.1744 11.1461C16.2339 11.1213 16.2846 11.0795 16.3203 11.0259C16.3559 10.9723 16.3748 10.9094 16.3746 10.845C16.374 10.7589 16.3399 10.6764 16.2796 10.615C16.218 10.5557 16.1361 10.5221 16.0506 10.521Z" fill="#161E32"/>
                <path d="M16.0506 11.8521C15.9865 11.8521 15.9238 11.871 15.8706 11.9066C15.8173 11.9422 15.7758 11.9929 15.7512 12.0521C15.7267 12.1113 15.7203 12.1764 15.7328 12.2393C15.7453 12.3021 15.7762 12.3598 15.8215 12.4052C15.8668 12.4505 15.9245 12.4813 15.9874 12.4938C16.0502 12.5063 16.1154 12.4999 16.1746 12.4754C16.2338 12.4509 16.2844 12.4093 16.32 12.356C16.3556 12.3028 16.3746 12.2401 16.3746 12.1761C16.3743 12.0902 16.3401 12.0079 16.2794 11.9472C16.2187 11.8865 16.1364 11.8523 16.0506 11.8521Z" fill="#161E32"/>
                <path d="M16.0506 14.5181C15.9865 14.5181 15.9238 14.5371 15.8706 14.5727C15.8173 14.6083 15.7758 14.6589 15.7512 14.7181C15.7267 14.7773 15.7203 14.8424 15.7328 14.9053C15.7453 14.9681 15.7762 15.0259 15.8215 15.0712C15.8668 15.1165 15.9245 15.1473 15.9874 15.1598C16.0502 15.1723 16.1154 15.1659 16.1746 15.1414C16.2338 15.1169 16.2844 15.0753 16.32 15.0221C16.3556 14.9688 16.3746 14.9062 16.3746 14.8421C16.3743 14.7562 16.3401 14.674 16.2794 14.6133C16.2187 14.5525 16.1364 14.5183 16.0506 14.5181Z" fill="#161E32"/>
                <path d="M16.0506 13.1851C15.9865 13.1851 15.9239 13.204 15.8707 13.2396C15.8174 13.2752 15.7759 13.3257 15.7513 13.3849C15.7268 13.444 15.7203 13.5091 15.7327 13.5719C15.7451 13.6347 15.7759 13.6925 15.8211 13.7378C15.8663 13.7832 15.924 13.8141 15.9867 13.8267C16.0495 13.8393 16.1146 13.8331 16.1738 13.8087C16.2331 13.7843 16.2838 13.7429 16.3195 13.6898C16.3552 13.6366 16.3744 13.5741 16.3746 13.5101C16.3746 13.424 16.3404 13.3415 16.2797 13.2806C16.219 13.2197 16.1366 13.1853 16.0506 13.1851Z" fill="#161E32"/>
                </svg>
                New transition
              </span>

            </li>
          </ul>
        </div>
        
          <!--<div class="text-right">
            <router-link class="btn btn-primary" to="storyEditView">Edit Story</router-link>
          </div>-->
        <ul class="controls-topbar control__btns">
          
          <li  @click="undo()" class="coming_soon" title="coming soon">
            <span 
              class="nav-link"
              :class="[undoButtonIsActive ? '' : 'disabled']"
            >
              <!-- Undo -->
              <img :src="undoSvg"/>
            </span>
          </li>
          <li  @click="redo()" class="coming_soon" title="coming soon">
            <span 
              class="nav-link"
              :class="[redoButtonIsActive ? '' : 'disabled']"
            >
              <!-- Redo -->
              <img :src="redoSvg"/>
            </span>
          </li>
          <li  @click="deleteDiagramNodes()" title="delete">
            <span 
              class="nav-link"
              :class="[deleteButtonIsActive ? '' : 'disabled']"
            >
            <!-- delete -->
              <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.07961 15.911C2.08172 16.4327 2.28998 16.9325 2.659 17.3013C3.02802 17.6701 3.52787 17.8782 4.04961 17.88H11.9496C12.4719 17.8789 12.9725 17.6713 13.3422 17.3024C13.7118 16.9334 13.9205 16.4332 13.9226 15.911V4.55999H2.07961V15.911ZM15.3996 1.6H11.6996L10.4606 0.119995H5.53861L4.29961 1.6H0.599609V3.08H15.3996V1.6Z" fill="#fff"/>
                    </svg>
            </span>
          </li>
          <li  @click="dublicate()" class="coming_soon" title="coming soon">
            <span 
              class="nav-link"
              :class="[redoButtonIsActive ? '' : 'disabled']"
            >
            <!-- dublicate -->
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.18378 7.5509H16.5308C16.9639 7.5509 17.3792 7.72295 17.6855 8.0292C17.9917 8.33544 18.1638 8.75081 18.1638 9.1839V16.5309C18.1638 16.964 17.9917 17.3794 17.6855 17.6856C17.3792 17.9919 16.9639 18.1639 16.5308 18.1639H9.18378C8.75068 18.1639 8.33532 17.9919 8.02908 17.6856C7.72283 17.3794 7.55078 16.964 7.55078 16.5309V9.1839C7.55078 8.75081 7.72283 8.33544 8.02908 8.0292C8.33532 7.72295 8.75068 7.5509 9.18378 7.5509V7.5509Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4.28494 12.4489H3.46894C3.03584 12.4489 2.62048 12.2769 2.31423 11.9706C2.00799 11.6644 1.83594 11.249 1.83594 10.8159V3.46894C1.83594 3.03584 2.00799 2.62048 2.31423 2.31423C2.62048 2.00799 3.03584 1.83594 3.46894 1.83594H10.8159C11.249 1.83594 11.6644 2.00799 11.9706 2.31423C12.2769 2.62048 12.4489 3.03584 12.4489 3.46894V4.28494" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </li>
          <router-link :to="{ name: 'simulation' }">
            <span title="play"
              class="nav-link"
              :class="[deleteButtonIsActive ? '' : 'disabled']"
            >
            <!-- play -->
              <i class="fab fa-unity fa-xl" ></i>
            </span>
          </router-link>
          
        </ul>

        <div id="myDiagramDiv"></div>
      </div>
    </div>
</template>
<script>
import MainStoryHeader from "../components/v2/main-story-view/header";
import go, { Margin } from "gojs";
import Swal from 'sweetalert'
import { db, timelinesRef } from "../firebaseDB";
import { parseExport } from "../data/export-parser";
import _ from "lodash";
import sidebar from "../components/profile/sidebar";
const $ = go.GraphObject.make;
export default {
  components: {
    MainStoryHeader,
    sidebar,
  },
  data() {
    return {
      diagram: "",
      addScene: require('../assets/addScene.svg'),
      addLogic: require('../assets/addLogic.svg'),
      addPage: require('../assets/addPage.svg'),
      addGroup: require('../assets/addGroup.svg'),
      addTransition: require('../assets/addTransition.svg'),
      undoSvg: require('../assets/undo.svg'),
      redoSvg: require('../assets/redo.svg'),
      duplicateSvg: require('../assets/duplicate.svg'),
      deleteSvg: require('../assets/delete.svg'),
      diagramData: null,
      currentNode: null,
      savedChanges: false,
      nodeShapes: {
        Scene:"M15 0a14.85 14.85 0 1 1 0 29.7A14.85 14.85 0 0 1 15 0z.M16.868 10.296h-6.57a1.09 1.09 0 0 0-1.089 1.089v6.57a1.09 1.09 0 0 0 1.089 1.089h6.57a1.089 1.089 0 0 0 1.089-1.089v-6.57a1.09 1.09 0 0 0-1.089-1.089zm4.315.859l-2.5 1.722v3.586l2.5 1.72a.729.729 0 0 0 1.148-.588v-5.852a.73.73 0 0 0-1.148-.588z",
        Page: "M10 0a10 10 0 1 1 0 20 10 10 0 0 1 0-20z.M11.083 7.812V5.333H7.438A.436.436 0 0 0 7 5.771v8.462a.436.436 0 0 0 .438.438h6.125a.436.436 0 0 0 .437-.438V8.25h-2.479a.439.439 0 0 1-.438-.438zM14 7.555v.111h-2.333V5.333h.111a.437.437 0 0 1 .31.128l1.784 1.786a.436.436 0 0 1 .128.308z",
        User: "M20.5,7.1c0,3.4-2.8,8.9-6.2,8.9S8.1,10.5,8.1,7.1,9,0,14.3,0,20.5,3.7,20.5,7.1Zm2.4,10.7H21.1a3.4,3.4,0,0,1-3-1.8,5.9,5.9,0,0,1-4,1.8A6.1,6.1,0,0,1,10,16a3.4,3.4,0,0,1-3,1.8H5.3s-3.2.9-5.3,5.4v3.6a1.8,1.8,0,0,0,1.8,1.8H26.4a1.8,1.8,0,0,0,1.7-1.8V23.2C26,18.7,22.9,17.8,22.9,17.8Z",
        Logic: "M14.849.302a14.849 14.849 0 1 1 0 29.698 14.849 14.849 0 0 1 0-29.698z.M22.655 6.995H7.04a.33.33 0 0 0-.348.348v15.615a.33.33 0 0 0 .348.348h7.808a.323.323 0 0 0 .344-.311v-3.053a.331.331 0 0 0-.348-.348h-.652a.358.358 0 0 0-.311.174 1.32 1.32 0 0 1-1.18.7 1.388 1.388 0 1 1 0-2.775 1.32 1.32 0 0 1 1.18.7.366.366 0 0 0 .31.174h.66a.331.331 0 0 0 .348-.348v-2.718h2.36v.174a1.994 1.994 0 0 0-.868 1.662 2.09 2.09 0 0 0 2.083 2.083 2.04 2.04 0 0 0 2.046-2.117 2.009 2.009 0 0 0-.866-1.665v-.143h2.708a.331.331 0 0 0 .348-.348V7.343a.334.334 0 0 0-.351-.348h-.004zm-8.155.7v2.672a.33.33 0 0 0 .348.348h.659a.358.358 0 0 0 .31-.174 1.32 1.32 0 0 1 1.18-.7 1.388 1.388 0 1 1 0 2.775 1.32 1.32 0 0 1-1.18-.7.368.368 0 0 0-.31-.174h-.66a.33.33 0 0 0-.347.348v2.708h-2.324v-.14a2.009 2.009 0 0 0 .866-1.663 2.083 2.083 0 1 0-3.94.94c.151.29.371.539.64.725v.14h-2.35V7.695H14.5zm0 10.132h-.14a2.009 2.009 0 0 0-1.665-.866 2.083 2.083 0 0 0 0 4.166 2.01 2.01 0 0 0 1.665-.866h.14v2.361H7.392v-7.127h2.672a.331.331 0 0 0 .348-.348v-.652a.358.358 0 0 0-.174-.311 1.32 1.32 0 0 1-.7-1.18 1.388 1.388 0 1 1 2.775 0 1.32 1.32 0 0 1-.7 1.18.368.368 0 0 0-.174.311v.659a.33.33 0 0 0 .348.348h2.708l.005 2.325zm7.844-3.019h-2.708a.33.33 0 0 0-.348.348v.659a.358.358 0 0 0 .174.311 1.321 1.321 0 0 1 .7 1.18 1.387 1.387 0 1 1-2.775 0 1.32 1.32 0 0 1 .7-1.18.366.366 0 0 0 .174-.311v-.659a.331.331 0 0 0-.348-.348h-2.721v-2.329h.14a2.009 2.009 0 0 0 1.665.866 2.083 2.083 0 1 0-.94-3.94c-.29.152-.539.371-.725.64h-.14v-2.35h7.149l.003 7.113z",
        Chatbot:"M58,16H56V11.7A6.1,6.1,0,0,0,59.7,4,6,6,0,1,0,48.3,8,6.2,6.2,0,0,0,52,11.7V16H28V11.7A6.1,6.1,0,0,0,31.7,4,6,6,0,0,0,20.3,8,6.2,6.2,0,0,0,24,11.7V16H22A10,10,0,0,0,12,26V58A10,10,0,0,0,22,68h6V78a2,2,0,0,0,2,2,1.7,1.7,0,0,0,1.2-.4L46.7,68H58A10,10,0,0,0,68,58V26A10,10,0,0,0,58,16ZM54.9,51.8a35.3,35.3,0,0,1-29.8,0,2,2,0,1,1,1.8-3.6c7.5,3.8,18.7,3.8,26.2,0a2,2,0,0,1,1.8,3.6ZM33.8,38.2H29.1V29.6h4.7Zm16,0H45.1V29.6h4.7ZM0,38v8a6,6,0,0,0,6,6H8V32H6A6,6,0,0,0,0,38Zm74-6H72V52h2a6,6,0,0,0,6-6V38A6,6,0,0,0,74,32Z",
        Universal: "M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z",
      },
      nodeColors: {
        Scene: "#FF99C8",
        Page: "#FCF6BD",
        User: "#bf975f",
        Logic: "#D0F4DE",
        Chatbot: "#E4C1F9",
        Universal: "#fff",
        Start: "#fff",
      },
      undoButtonIsActive: false,
      redoButtonIsActive: false,
      deleteButtonIsActive: false,
      selectedNodeKey:[],
      wrongNodes:[]
    };
  },
  created() {
    console.log("story id-->", this.storyID);
    window.onbeforeunload = this.saveTreeToDB;
    db.ref(`stories/${this.storyID}`)
      .once("value")
      .then((snapshot) => {
        this.story = snapshot.val();
        this.diagram.model.nodeDataArray = this.story.diagram
          ? this.story.diagram.nodeDataArray
          : [];
        this.diagram.model.linkDataArray = this.story.diagram
          ? this.story.diagram.linkDataArray
          : [];
        const startNode = (this.diagram.model.nodeDataArray || []).find(
          (o) => o.key == "Start"
        );
        if (!startNode) {
          this.addNode("Start");
        }
      });
  },
  methods: {
    showErrorToast(text) {
      this.$toast(text, {
        timeout: 3000,
        type: "error",
        showCloseButtonOnHover: true,
      });
    },
    toggleSidebar() {
      if (window.innerWidth >= 1024) {
        this.toggle1024();
      } else if (window.innerWidth >= 820) {
        this.toggle820();
      } else {
        this.toggle0();
      }
    },
    toggle1024() {
      const sideBar = document.getElementById('controls-sidebar');
      const svg = document.getElementById('toggle-sidebar-SVG');
      if (sideBar.style.top == '-471px') {
        sideBar.style.top = '15%';
        svg.style.transform = 'rotate(180deg)';
        console.log('1024');
      }
      else {
        sideBar.style.top = '-471px';
        svg.style.transform = 'rotate(0)';
      }
    },
    toggle820() {
      const sideBar = document.getElementById('controls-sidebar');
      const svg = document.getElementById('toggle-sidebar-SVG');
      if (sideBar.style.bottom == '-80px') {
        sideBar.style.bottom = '0';
        svg.style.transform = 'rotate(180deg)';
        console.log('820');
      }
      else {
        sideBar.style.bottom = '-80px';
        svg.style.transform = 'rotate(0)';
      }
    },
    toggle0() {
      const sideBar = document.getElementById('controls-sidebar');
      const svg = document.getElementById('toggle-sidebar-SVG');
      if (sideBar.style.bottom == '0px') {
        sideBar.style.bottom = '68px';
        svg.style.transform = 'rotate(180deg)';
        console.log('0');
      }
      else {
        sideBar.style.bottom = '0px';
        svg.style.transform = 'rotate(0)';
      }
    },
    createGroup(name) {
      const newnode = {
        key: name,
        isGroup: true,
        horiz: true,
        group: "Group",
        fig: "RoundedRectangle",
        groupTitle: name,
        groupLabel: name,
      };
      this.diagram.startTransaction("add group node");
      this.diagram.model.addNodeData(newnode);
      this.diagram.commitTransaction("add group node");
      this.saveTreeToDB();
    },
   enable(name, ok) {
  
    },
    addNode(category) {
      this.diagram.model.commit((d) => {
        this.addNodeToPlane(category);
      }, "add node");
    },
    getLinkNode(subNodes, node) {
      subNodes = subNodes.filter((o) => o.key);
      let newlink = {};
      let lastAddedNodeInAGroup = subNodes[subNodes.length - 1];
      console.log(
        "LINE 106---------->",
        lastAddedNodeInAGroup.key,
        node.key,
        subNodes.filter((o) => o.key),
        this.diagram.model.nodeDataArray.filter((o) => o.ke)
      );
      lastAddedNodeInAGroup =
        lastAddedNodeInAGroup && lastAddedNodeInAGroup.isGroup
          ? subNodes[subNodes.length - 2]
          : lastAddedNodeInAGroup.key == node.key
          ? subNodes[subNodes.length - 2]
          : lastAddedNodeInAGroup;
      console.log("LINE 111---------->", lastAddedNodeInAGroup.key, node.key);
      newlink = { from: lastAddedNodeInAGroup.key, to: node.key };
      return newlink;
    },
    addNodeToPlane(name) {
      const nodeDataArray = this.diagram.model.nodeDataArray;
      const groupNodesArray = nodeDataArray.filter((o) => o.isGroup);
      const groupNode = groupNodesArray[groupNodesArray.length - 1];
      let node = nodeDataArray[nodeDataArray.length - 1];
      const nodeDataArrayWithoutGroups = nodeDataArray.filter(
        (o) => !o.isGroup
      );
      // node = (node && node.isGroup) ? nodeDataArray[nodeDataArray.length - 2] : node;
      if (node && node.isGroup && nodeDataArray.length > 1) {
        node = nodeDataArray[nodeDataArray.length - 2];
      }
    let selnode = this.diagram.selection.first();
     if (nodeDataArray.length == 1) {
        this.diagram.nodes.each(function(n) {
              if (n.data.key=='Start') { selnode = n}
        });
     }
      let key=''
      let scenesArray = nodeDataArray.filter((node) => node.category === "Scene")
      let pagesArray  = nodeDataArray.filter((node) => node.category === "Page")
      let logicsArray = nodeDataArray.filter((node) => node.category === "Logic")
      let scenesCount = 0
      let pagesCount = 0
      let logicsCount = 0
      if(nodeDataArray.length>1 && scenesArray.length>0){
       scenesCount = parseInt(scenesArray[scenesArray.length - 1].key.replace(/[^0-9]/g,""))
      }
      if(nodeDataArray.length>1 && pagesArray.length>0){
       pagesCount  = parseInt(pagesArray[pagesArray.length - 1].key.replace(/[^0-9]/g,""))
      }
      if(nodeDataArray.length>1 && logicsArray.length>0){
       logicsCount = parseInt(logicsArray[logicsArray.length - 1].key.replace(/[^0-9]/g,""))
      }
       switch (name) {
          case 'Start':
            key = name
            break
          case 'Scene':
             key = name + (scenesCount+1)
            break
          case 'Page':
             key = name + (pagesCount+1)
            break
          case 'Logic':
             key = name + (logicsCount+1)
            break
       }
       // DT restrictions
        let errorMessages = [
          'you can\'t link to multi-nodes',
          'you can\'t link to multi-pages',
          'you can\'t link to multi-logic nodes',
          'you already linked to logic node',
          'you can\'t link to a Scene manually',
          'you can\'t link to a Page manually',
          'you can only start by single node',
          'you can only start by Page or Scene',
        ] 
        let existedSceneLink =  this.diagram.model.linkDataArray.filter((node) => node.from === selnode.data.key).filter((node) => node.to.startsWith("Scene"));
        let existedPageLink =  this.diagram.model.linkDataArray.filter((node) => node.from === selnode.data.key).filter((node) => node.to.startsWith("Page"));
        let existedLogicLink =  this.diagram.model.linkDataArray.filter((node) => node.from === selnode.data.key).filter((node) => node.to.startsWith("Logic"));   
        if(name!='Start' && (existedSceneLink.length>0 || existedPageLink.length>0 || existedLogicLink.length>0 ) ){
          this.showErrorToast(errorMessages[0]);
        }else if(name!='Start' &&  name=='Page' && existedPageLink.length>0){
          this.showErrorToast(errorMessages[1]);
        }else if(name!='Start' && name=='Logic' && existedLogicLink.length>0){
          this.showErrorToast(errorMessages[2]);
        }else if((name!='Start' && selnode.data.category=='Logic' && name=='Logic')
        ||(name!='Start' && (selnode.data.category=='Scene' || selnode.data.category=='Page') && existedLogicLink.length>0)){
          this.showErrorToast(errorMessages[3]);
        }else if(name!='Start' && name=='Scene' && selnode.data.category=='Logic'){
          this.showErrorToast(errorMessages[4]);
        }else if(name!='Start' && name=='Page' && selnode.data.category=='Logic'){
          this.showErrorToast(errorMessages[5]);
         }else if(name!='Start' && selnode.data.key=='Start' && (existedPageLink.length>0 || existedSceneLink.length>0)){
          this.showErrorToast(errorMessages[6]);
       }else if(name!='Start' && selnode.data.key=='Start' && name!='Scene' && name!='Page'){
          this.showErrorToast(errorMessages[7]);
        }else{
      let newnode = {
        key: key,
        category: name,
        isGroup: false,
        ungroupable: true,
        path: this.getNodeShape(name),
        fig: "Square",
        color: this.getNodeColor(name),
        width: 60,
        height: 60,
        margin: 4,
      };
      if (selnode && selnode.data) {
        if (selnode.data.isGroup) {
          console.log("LINE 143------->");
          newnode["group"] = selnode.data.key;
          newnode["member"] = selnode.data.key;
        } else {
          console.log("LINE 147------->");
          newnode["group"] = selnode.data.group;
          newnode["member"] = selnode.data.member;
        }
      } else {
        console.log("LINE 152------->");
        if (groupNode) {
          newnode["group"] = groupNode.key;
          newnode["member"] = groupNode.key;
        }
      }
      this.diagram.startTransaction("add node and link");
      // have the Model add the node data
      this.diagram.model.addNodeData(newnode);
      let newlink = {};
      if (nodeDataArrayWithoutGroups.length >= 1) {
        if (selnode && selnode.data) {
          if (selnode.data.isGroup) {
            // let selectedGroupNode = nodeDataArray.filter(o => o.key !== newnode.key).find(o => o.key == selnode.data.key);
            // const selectedGroupSubNodes = selectedGroupNode ? (selectedGroupNode.subNodes || []).filter(o => o.key !== newnode.key) : [];
            let selectedGroupSubNodes = nodeDataArray
              .filter((o) => o.key !== newnode.key)
              .filter((o) => o.group == selnode.data.key);
            console.log(
              "LINE 167------->",
              selnode.data.key,
              selectedGroupSubNodes.length,
              nodeDataArray,
              selectedGroupSubNodes.map((o) => o.key)
            );
            if (selectedGroupSubNodes.length) {
              newlink = this.getLinkNode(selectedGroupSubNodes, newnode);
              console.log("LINE 168--------------->", newlink);
            } else {
              newlink = { from: node.key, to: newnode.key };
              console.log("LINE 171--------------->", newlink);
            }
          } else {
            newlink = { from: selnode.data.key, to: newnode.key };
            console.log("LINE 175--------------->", newlink);
          }
        } else {
          if (groupNode) {
            const subNodes = nodeDataArray
              .filter((o) => o.key !== newnode.key)
              .filter((o) => o.group == groupNode.key);
            console.log(
              "LINE 182------->",
              subNodes.map((o) => o.key)
            );
            if (subNodes.length) {
              newlink = this.getLinkNode(subNodes, newnode);
              console.log("LINE 183--------------->", newlink);
            } else {
              newlink = { from: node.key, to: newnode.key };
              console.log("LINE 186--------------->", newlink);
            }
          } else {
            newlink = { from: node.key, to: newnode.key };
            console.log("LINE 183--------------->", newlink);
          }
        }
        this.diagram.model.addLinkData(newlink);
      }
      this.diagram.commitTransaction("add node and link");
      this.saveTreeToDB();
    }
    },
    getNodeShape(category) {
      let svg = this.nodeShapes[category];
      if (typeof svg === "string") {
        svg = this.nodeShapes[category] = go.Geometry.parse(svg, true); // fill each geometry
      }
      return svg;
    },
    getNodeColor(category) {
      return this.nodeColors[category];
    },
    highlightGroup(e, grp, show) {
      if (!grp) return;
      e.handled = true;
      if (show) {
        // cannot depend on the grp.diagram.selection in the case of external drag-and-drops;
        // instead depend on the DraggingTool.draggedParts or .copiedParts
        const tool = grp.diagram.toolManager.draggingTool;
        const map = tool.draggedParts || tool.copiedParts; // this is a Map
        // now we can check to see if the Group will accept membership of the dragged Parts
        if (grp.canAddMembers(map.toKeySet())) {
          grp.isHighlighted = true;
          return;
        }
      }
      grp.isHighlighted = false;
    },
    finishDrop(e, grp) {
      const ok =
        grp !== null && grp.addMembers
          ? grp.addMembers(grp.diagram.selection, true)
          : e.diagram.commandHandler.addTopLevelParts(
              e.diagram.selection,
              true
            );
      if (ok) {
        let diagram = null;
        if (grp !== null) {
          diagram = grp.diagram;
          console.log(
            "LINE 205 --> Nodes dropped into Group with key " + grp.key + ":"
          );
        } else {
          diagram = e.diagram;
          console.log("LINE 208 --> Nodes dropped into Diagram:");
        }
        diagram.selection.each(function (part) {
          if (part && part.key == "Start") {
            e.diagram.currentTool.doCancel();
          }
          console.log("LINE 211-------------->", part.toString());
        });
      } else {
        e.diagram.currentTool.doCancel();
      }
      this.saveTreeToDB();
    },
    updateModel(val) {
      // No GoJS transaction permitted when replacing Diagram.model.
      if (val instanceof go.Model) {
        this.diagram.model = val;
      } else {
        let m = new go.GraphLinksModel();
        if (val) {
          for (let p in val) {
            m[p] = val[p];
          }
        }
        this.diagram.model = m;
      }
    },
    drawLink(e, button) {
      let node = button.part.adornedPart;
      let tool = e.diagram.toolManager.linkingTool;
      tool.startObject = node.port;
      e.diagram.currentTool = tool;
      tool.doActivate();
    },
    showData(data) {
      if (data.key == "Start") {
        this.$router.push("newprofile/update-story/step-1");
        return;
      }
      const nodeDataArray = (this.diagram.model.nodeDataArray || [])
        .filter((n) => n.key !== "Start")
        .filter((n) => n.category == "Scene");
      const nodePosition = nodeDataArray.findIndex((n) => n.key == data.key);
      let selectedLogic = {
        key: data.key,
        name: data.key,
        category: data.category,
        nodePosition: nodePosition,
      };
      localStorage.setItem("selectedLogic", JSON.stringify(selectedLogic));
      this.$store.dispatch("saveSelectedLogic", selectedLogic);
      if (data && data.key && data.key.startsWith("Logic")) {
        this.$store.dispatch("listUserStories");
        this.$router.push("logicEditView");
      } else if (data && data.key && data.key.startsWith("Scene")) {
        this.$router.push("storyEditView");
      }
    },
    mouseEnter(e, obj) {
      // let shape = obj.findObject('SHAPE')
      // shape.stroke = 'yellow'
    },
    mouseLeave(e, obj) {
      // let shape = obj.findObject('SHAPE')
      // shape.stroke = this.getNodeColor(obj.data.category)
    },
    saveTreeToDB(shouldEditGroupTitle, newGroupName, oldGroupName) {
      // console.log('checking--->', this.diagram);
      let nodeDataArray = this.diagram.model.nodeDataArray;
      // console.log('checking--->', typeof shouldEditGroupTitle, shouldEditGroupTitle, newGroupName, oldGroupName)
      let linkDataArray = this.diagram.model.linkDataArray;
      let subNodes = [];
      let tempGroupTitle = "";
      const groupByCollection = _.groupBy(
        nodeDataArray.filter((n) => n.group),
        "group"
      );
      nodeDataArray = (nodeDataArray || []).map((node) => {
        let groupTitle = this.getGroupTitle(groupByCollection[node.key] || []);
        let groupInfo = this.getNodesCountInGroupByCategory(
          groupByCollection[node.key] || []
        );
        this.diagram.model.commit(function (m) {
          // if ((groupByCollection[node.key] || []).length) {
          tempGroupTitle = node.key;
          if (
            shouldEditGroupTitle &&
            oldGroupName == node.groupTitle &&
            newGroupName
          ) {
            tempGroupTitle = newGroupName;
          }
          m.set(node, "groupTitle", groupTitle);
          m.set(node, "groupLabel", tempGroupTitle);
          m.set(node, "pageNodesCount", groupInfo.pageNodesCount);
          m.set(node, "pageNodeCategory", groupInfo.pageNodeCategory);
          m.set(node, "sceneNodesCount", groupInfo.sceneNodesCount);
          m.set(node, "sceneNodeCategory", groupInfo.sceneNodeCategory);
          m.set(node, "logicNodesCount", groupInfo.logicNodesCount);
          m.set(node, "logicNodeCategory", groupInfo.logicNodeCategory);
          // }
        }, "changed group name");
        subNodes = (node.isGroup ? groupByCollection[node.key] || [] : []).map(
          (o) => {
            return {
              __gohashid: o.__gohashid,
              key: o.key,
              category: o.category || "",
              isGroup: o.isGroup,
              color: o.color || "",
              group: o.group || "",
              groupTitle: o.groupTitle || "",
              member: o.member || "",
              width: o.width || 60,
              height: o.height || 60,
              margin: 4,
              ungroupable: o.ungroupable,
              fig: o.fig || "Square",
              groupLabel: o.groupLabel || o.key || "",
              pageNodesCount: groupInfo.pageNodesCount,
              pageNodeCategory: groupInfo.pageNodeCategory,
              sceneNodesCount: groupInfo.sceneNodesCount,
              sceneNodeCategory: groupInfo.sceneNodeCategory,
              logicNodesCount: groupInfo.logicNodesCount,
              logicNodeCategory: groupInfo.logicNodeCategory,
            };
          }
        );
        return {
          __gohashid: node.__gohashid,
          key: node.key,
          category: node.category || "",
          isGroup: node.isGroup,
          color: node.color || "",
          group: node.group || "",
          groupTitle: node.groupTitle || "",
          member: node.member || "",
          width: node.width || 60,
          height: node.height || 60,
          margin: 4,
          ungroupable: node.ungroupable || true,
          fig: node.fig || "RoundedRectangle",
          subNodes: subNodes,
          groupLabel: node.groupLabel || node.key || "",
          pageNodesCount: groupInfo.pageNodesCount,
          pageNodeCategory: groupInfo.pageNodeCategory,
          sceneNodesCount: groupInfo.sceneNodesCount,
          sceneNodeCategory: groupInfo.sceneNodeCategory,
          logicNodesCount: groupInfo.logicNodesCount,
          logicNodeCategory: groupInfo.logicNodeCategory,
        };
      });
      let updates = {};
      // this.updateLogicNode()
      updates[`stories/${this.storyID}/diagram`] = {
        nodeDataArray,
        linkDataArray,
      };
      console.log("updates-------------->", updates);
      db.ref()
        .update(updates)
        .then((snapshot) => {
          console.log("snapshot---------->", snapshot);
          this.save = false;
          this.savedChanges = true;
          if (this.savedChanges === true) {
            setTimeout(() => {
              this.savedChanges = false;
            }, 3000);
          }
          console.log("All information saved");
          // this.$toast('All data saved', {
          //   timeout: 3000,
          //   type: 'success',
          //   showCloseButtonOnHover: true
          // })
        })
        .catch((e) => {
          console.log("ERROR--------------->", e);
        });
    },
    exportFile() {
      let nodeArray = this.diagramData.nodeDataArray;
      let linkArray = this.diagramData.linkDataArray;
      parseExport(nodeArray, linkArray, this.storyID);
    },
    getGroupTitle(nodes) {
      const pageNodes = nodes.filter((n) => n.category == "Page").length;
      const sceneNodes = nodes.filter((n) => n.category == "Scene").length;
      const logicNodes = nodes.filter((n) => n.category == "Logic").length;
      let groupTitle = "";
      if (pageNodes) {
        groupTitle += ` ${pageNodes} ${pageNodes > 1 ? "P" : "P"}`;
      }
      if (sceneNodes) {
        groupTitle += ` ${pageNodes ? "+" : ""} ${sceneNodes} ${
          sceneNodes > 1 ? "S" : "S"
        }`;
      }
      if (logicNodes) {
        groupTitle += ` ${pageNodes || sceneNodes ? "+" : ""} ${logicNodes} ${
          logicNodes > 1 ? "L" : "L"
        }`;
      }
      return groupTitle;
    },
    getNodesCountInGroupByCategory(nodes) {
      const pageNodes = nodes.filter((n) => n.category == "Page").length;
      const sceneNodes = nodes.filter((n) => n.category == "Scene").length;
      const logicNodes = nodes.filter((n) => n.category == "Logic").length;
      return {
        pageNodesCount: pageNodes > 0 ? pageNodes : null,
        pageNodeCategory: pageNodes > 0 ? "Page" : null,
        sceneNodesCount: sceneNodes > 0 ? sceneNodes : null,
        sceneNodeCategory: sceneNodes > 0 ? "Scene" : null,
        logicNodesCount: logicNodes > 0 ? logicNodes : null,
        logicNodeCategory: logicNodes > 0 ? "Logic" : null,
      };
    },
    editGroupTitle(thisTextBlock, oldGroupName, newGroupName) {
      this.saveTreeToDB(true, newGroupName, oldGroupName);
    },
    undo() {
      const cmdhnd = this.diagram.commandHandler;
      const canUndo = cmdhnd.canUndo();
      if (canUndo) {
        cmdhnd.undo();
        this.saveTreeToDB();
      }
    },
    redo() {
      const cmdhnd = this.diagram.commandHandler;
      const canRedo = cmdhnd.canRedo();
      if (canRedo) {
        cmdhnd.redo();
        this.saveTreeToDB();
      }
    },
    dublicate(){},
    deleteDiagramNodes() {
      const cmdhnd = this.diagram.commandHandler;
      const canDeleteSelection = cmdhnd.canDeleteSelection();
      if (canDeleteSelection) {
         Swal({
        title: `Are you sure you want to delete this node ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        focusConfirm: false,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!'
      }).then((result) => {
        if (result) {
 let proRef = db.ref('stories').child('/' + localStorage.getItem('storyId'))
    proRef.once('value')
        .then(snapshot => {
      let storyData = snapshot.val();
                this.selectedNodeKey.forEach(element => {
                if(storyData.json && storyData.json.mainStory){
              let nodePosition= storyData.json.mainStory.nodes.findIndex((n) => n.name == element);
                if(nodePosition>=0){
                   if(storyData.json.mainStory.nodes.length>1){
                      let prevNodePosition= storyData.json.mainStory.nodes.findIndex((n) => n.name == element)-1;
                      storyData.json.mainStory.nodes[prevNodePosition].nextNodeID =-1
                      storyData.json.mainStory.nodes.splice(nodePosition, 1);
                  }
              }
                }
    })
             
       db.ref(`stories/${this.storyID}/`).update(storyData).then((snapshot) => {});
        cmdhnd.deleteSelection();     

      })
   
        }
           })
      }
    },
    makeButton(text, action, visiblePredicate) {
      return $(
        "ContextMenuButton",
        $(go.TextBlock, text, {
          font: "Bold 10pt Sans-Serif",
          editable: false,
          margin: new go.Margin(15, 40, 15, 40),
        }),
        { click: action },
        visiblePredicate
          ? new go.Binding("visible", "", function (o, e) {
              return o.diagram ? visiblePredicate(o, e) : false;
            }).ofObject()
          : {}
      );
    },
  },
  mounted() {
    localStorage.setItem("selectedLogic", JSON.stringify({}));
      let storyData,inJson,emptySubnodes
            db.ref("stories").child("/" + localStorage.getItem("storyId"))
                .on('value', (snapshot) => {
                    this.wrongNodes = []
                    storyData = snapshot.val();
                    }) 
                    // check if something wrong with node
            if (storyData.diagram && storyData.diagram.nodeDataArray) {
              let errMessage =''
                storyData.diagram.nodeDataArray.forEach(element => {
                     inJson = false
                     emptySubnodes=false
                    if (storyData.json){
                      if (storyData.json.mainStory.nodes.filter((node) => node.name === element.key).length>0)  inJson = true
                      storyData.json.mainStory.nodes.filter((node) => { 
                      if((node.name.startsWith('Logic') &&  node.nodeType=='SceneNode')
                       ||(node.conditions && node.conditions.length>0 && node.conditions[0].touch && node.conditions.filter((cond) => cond.touch.objectId=='').length>0)
                            ){
                            emptySubnodes = true
                            }
                      })
                    }
                    if ((element.key.startsWith('Scene') && !inJson)) {
                       this.wrongNodes.push({
                                        'key': element.key,
                                        'message':'this scene is not saved correctly'
                                      })
                    }
                    else if ((element.key.startsWith('Logic') && emptySubnodes )) {
                        this.wrongNodes.push({
                                        'key': element.key,
                                        'message':'this logic has empty subnodes'
                                      })
                    }else if ((element.key.startsWith('Logic') && !inJson )) {
                        this.wrongNodes.push({
                                        'key': element.key,
                                        'message':'this logic is not saved correctly'
                                      })
                    }
                })
            } 
    let partContextMenu = $(
      "ContextMenu",
     /* this.makeButton(
        "Cut",
        (e, obj) => {
          e.diagram.commandHandler.cutSelection();
        },
        (o) => {
          return o.diagram.commandHandler.canCutSelection();
        }
      ),
      this.makeButton(
        "Copy",
        (e, obj) => {
          e.diagram.commandHandler.copySelection();
        },
        (o) => {
          return o.diagram.commandHandler.canCopySelection();
        }
      ),
      this.makeButton(
        "Paste",
        (e, obj) => {
          e.diagram.commandHandler.pasteSelection(
            e.diagram.toolManager.contextMenuTool.mouseDownPoint
          );
        },
        (o) => {
          return o.diagram.commandHandler.canPasteSelection(
            o.diagram.toolManager.contextMenuTool.mouseDownPoint
          );
        }
      ),*/
      this.makeButton(
        "Delete",
        (e, obj) => {
           Swal({
        title: `Are you sure you want to delete this node ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        focusConfirm: false,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!'
      }).then((result) => {
        if (result) {
                let proRef = db.ref('stories').child('/' + localStorage.getItem('storyId'))
              proRef.once('value')
                    .then(snapshot => {
                let storyData = snapshot.val();
                 this.selectedNodeKey.forEach(element => {
                   if(storyData.json && storyData.json.mainStory){
              let nodePosition= storyData.json.mainStory.nodes.findIndex((n) => n.name == element);
                if(nodePosition>=0){
                   if(storyData.json.mainStory.nodes.length>1){
                      let prevNodePosition= storyData.json.mainStory.nodes.findIndex((n) => n.name == element)-1;
                      storyData.json.mainStory.nodes[prevNodePosition].nextNodeID =-1
                      storyData.json.mainStory.nodes.splice(nodePosition, 1);
                  }
              }
                   }
              })
                db.ref(`stories/${this.storyID}/`).update(storyData).then((snapshot) => {});
                                   e.diagram.commandHandler.deleteSelection();

      })
        
         // this.saveTreeToDB();
        }
           })
        },
        (o) => {
          return o.diagram.commandHandler.canDeleteSelection();
        }
      ),
      this.makeButton(
        "Undo",
        (e, obj) => {
          e.diagram.commandHandler.undo();
          this.saveTreeToDB();
        },
        (o) => {
          return o.diagram.commandHandler.canUndo();
        }
      ),
      this.makeButton(
        "Redo",
        (e, obj) => {
          e.diagram.commandHandler.redo();
          this.saveTreeToDB();
        },
        (o) => {
          return o.diagram.commandHandler.canRedo();
        }
      ),
      this.makeButton(
        "Group",
        (e, obj) => {
          e.diagram.commandHandler.groupSelection();
          this.saveTreeToDB();
        },
        (o) => {
          return o.diagram.commandHandler.canGroupSelection();
        }
      ),
      this.makeButton(
        "Ungroup",
        (e, obj) => {
          e.diagram.commandHandler.ungroupSelection();
          this.saveTreeToDB();
        },
        (o) => {
          console.log("LINE 659---------------->");
          return o.diagram.commandHandler.canUngroupSelection();
        }
      )
    );
    // let diagram = new go.Diagram('myDiagramDiv')
    let diagram = $(go.Diagram, "myDiagramDiv", {
    initialContentAlignment: go.Spot.Left,
      mouseDrop: (e) => {
        this.finishDrop(e, null);
      },
      "commandHandler.archetypeGroupData": {
        key: "New Group",
        isGroup: true,
        color: "blue",
      },
      "undoManager.isEnabled": true,
      contextMenu: partContextMenu,
    });    
    const nodeTemplate = $(
      go.Node,
      "Auto",
      {
        contextMenu: partContextMenu,
        mouseEnter: this.mouseEnter,
        mouseLeave: this.mouseLeave,
        mouseDrop: this.finishDrop,
        linkConnected: function (node, link, port) {
          if (link.fromNode !== null) link.fromNode.invalidateConnectedLinks();
          if (link.toNode !== null) link.toNode.invalidateConnectedLinks();
        },
        linkDisconnected: function (node, link, port) {
          if (link.fromNode !== null) link.fromNode.invalidateConnectedLinks();
          if (link.toNode !== null) link.toNode.invalidateConnectedLinks();
        },
        // locationSpot: go.Spot.TopLeft,
        fromSpot: go.Spot.Center,
        toSpot: go.Spot.RightCenter,
      },
      // new go.Binding("location", "loc", go.Point.parse),
      new go.Binding("location", "loc", go.Point.parse).makeTwoWay(
        go.Point.stringify
      ),
      // $(go.Shape, "Square", { width: 100, height: 100, margin: 4, fill: "white" }),
      $(
        go.Shape,
        "RoundedRectangle",
        {
          fill: '#161E32',
          fromSpot: go.Spot.AllSides,
          fromLinkable: false,
          fromLinkableDuplicates: false,
          fromLinkableSelfNode: false,
          // toSpot: go.Spot.AllSides,
          toLinkable: false,
          toLinkableDuplicates: false,
          toLinkableSelfNode: false,
          stroke: "white",
          desiredSize: new go.Size(90, 110),
          strokeWidth: 2,
          margin: 0,
        },
        new go.Binding("stroke", "category", this.getNodeColor)
        ),
      $(
        go.Shape,
        {
          name: "SHAPE",
          cursor: "pointer",
          portId: "",
          width: 40,
          height: 40,
          fromSpot: go.Spot.AllSides,
          fromLinkable: true,
          fromLinkableDuplicates: false,
          fromLinkableSelfNode: false,
          // toSpot: go.Spot.AllSides,
          toLinkable: true,
          toLinkableDuplicates: false,
          toLinkableSelfNode: false,
          fill: null,
          // margin: 4,
          // margin: new go.Margin(10, 10, 10, 10),
          strokeWidth: 0.5,
        },
        new go.Binding("fill", "category", this.getNodeColor),
        new go.Binding("geometry", "category", this.getNodeShape)
      ),
      $(
        go.TextBlock,
        {
          alignment: go.Spot.BottomCenter,
          stroke: "white",
          font: "normal 10pt Sans-Serif",
          margin: new go.Margin(0, 0, 5, 0)
        },
        new go.Binding("text", "key", function(v) { return v.replace(/([a-z])(\d)/gi, '$1 $2') ; })
      ),
      $(
        go.TextBlock,
       { font: '20pt FontAwesome' ,position: new go.Point(0, 50),stroke:'white'},
        new go.Binding("text", "key",
         (node) => {
           let count = 0
            this.wrongNodes.forEach(element => {
             if( element.key===node) count+=1
            })
           return count > 0  ? "\uf071" : "";
            }
        ),
        {
      toolTip:                       
        $("ToolTip",
          $(go.TextBlock,
            { margin: 4 },
            new go.Binding("text", "key",
         (node) => {
           let errorMessg = ''
            this.wrongNodes.forEach(element => {
             if( element.key===node)  errorMessg = element.message;
            })
            return errorMessg 
            }
        )),
        ) 
    }
        ),
      // {
      //   selectionAdornmentTemplate: $(
      //     go.Adornment,
      //     "Spot",
      //     $(
      //       go.Panel,
      //       "Auto",
      //       $(go.Shape, { stroke: "red", strokeWidth: 2, fill: null }),
      //       $(go.Placeholder)
      //     ),
      //     $(
      //       go.Panel,
      //       "Vertical",
      //       { alignment: go.Spot.Right, alignmentFocus: go.Spot.Left },
      //       $(
      //         "Button",
      //         {
      //           // drawLink is defined below, to support interactively drawing new links
      //           click: this.drawLink, // click on Button and then click on target node
      //           actionMove: this.drawLink // drag from Button to the target node
      //         },
      //         $(go.Shape, {
      //           geometryString: "M0 0 L8 0 8 12 14 12 M12 10 L14 12 12 14"
      //         })
      //       )
      //     )
      //   )
      // }
    );
    const rootTemplate = $(
      go.Node,
      "Auto",
      {
        isTreeExpanded: true, // by default collapsed
        deletable: false,
        fromSpot: go.Spot.Right,
        toSpot: go.Spot.Left,
      },
      $(
        go.Panel,
        "Auto",
        // $(go.Shape, "RoundedRectangle", {
        //   fill: null,
        //   fromSpot: go.Spot.AllSides,
        //   fromLinkable: false,
        //   fromLinkableDuplicates: false,
        //   fromLinkableSelfNode: false,
        //   toSpot: go.Spot.AllSides,
        //   toLinkable: false,
        //   toLinkableDuplicates: false,
        //   toLinkableSelfNode: false,
        //   stroke: 'white',
        //   }),
        // $(
        //   go.Shape,
        //   "RoundedRectangle",
        //   {
        //     fill: null,
        //     fromSpot: go.Spot.AllSides,
        //     fromLinkable: false,
        //     fromLinkableDuplicates: false,
        //     fromLinkableSelfNode: false,
        //     // toSpot: go.Spot.AllSides,
        //     toLinkable: false,
        //     toLinkableDuplicates: false,
        //     toLinkableSelfNode: false,
        //     stroke: "white",
        //     desiredSize: new go.Size(100, 120),
        //     strokeWidth: 2,
        //   },
        //   new go.Binding("stroke", "category", this.getNodeColor)
        // ),
        // gear button
        $(
          go.Picture,
          {
            name: "Picture",
            cursor: "pointer",
            portId: "",
            desiredSize: new go.Size(50, 50),
            fromSpot: go.Spot.AllSides,
            fromLinkable: false,
            fromLinkableDuplicates: false,
            fromLinkableSelfNode: false,
            toSpot: go.Spot.AllSides,
            toLinkable: false,
            toLinkableDuplicates: false,
            toLinkableSelfNode: false,
            margin: 100,
            source: "../../static/files/settings.svg",
          }
          // new go.Binding("source", "settings.svg")
        )
        // $(go.TextBlock,
        //   {
        //     name: 'TEXTBLOCK',
        //     font: '16px Lato, sans-serif',
        //     editable: false,
        //     stroke: 'white',
        //     overflow: go.TextBlock.OverflowEllipsis,
        //     maxLines: 5,
        //     margin: 3,
        //     alignment: go.Spot.Center
        //   },
        //   new go.Binding('text', 'key').makeTwoWay()
        // ),
      ),
      {
        selectionAdornmentTemplate: $(
          go.Adornment,
          "Spot",
          $(
            go.Panel,
            "Auto",
            $(go.Shape,"RoundedRectangle", { stroke: "yellow", strokeWidth: 2, fill: null, desiredSize: new go.Size(100, 110)}),
            $(go.Placeholder)
          )
        ),
      }
      // $("TreeExpanderButton", {
      //   alignment: go.Spot.Right,
      //   alignmentFocus: go.Spot.Bottom,
      //   margin: new Margin(0, 0, 0, 0),
      //   fromSpot: go.Spot.Right,
      //   toSpot: go.Spot.Left
      // })
    );
    diagram.nodeTemplateMap.add("Start", rootTemplate);
    diagram.nodeTemplateMap.add("Page", nodeTemplate);
    diagram.nodeTemplateMap.add("Scene", nodeTemplate);
    diagram.nodeTemplateMap.add("User", nodeTemplate);
    diagram.nodeTemplateMap.add("Universal", nodeTemplate);
    diagram.nodeTemplateMap.add("Logic", nodeTemplate);
    diagram.nodeTemplateMap.add("Chatbot", nodeTemplate);
    diagram.groupTemplate = $(
      go.Group,
      "Auto",
      {
        contextMenu: partContextMenu,
        ungroupable: true,
        mouseEnter: this.mouseEnter,
        mouseLeave: this.mouseLeave,
        layout: $(go.LayeredDigraphLayout, { direction: 0, columnSpacing: 10 }),
        mouseDragEnter: (e, grp, prev) => {
          this.highlightGroup(e, grp, true);
        },
        mouseDragLeave: (e, grp, next) => {
          this.highlightGroup(e, grp, false);
        },
        computesBoundsAfterDrag: true,
        mouseDrop: this.finishDrop,
        handlesDragDropForMembers: true,
      },
      $(
        go.Shape,
        "RoundedRectangle", // surrounds everything
        {
          parameter1: 10,
          fill: "#4A8F8A",
        }
      ),
      $(
        go.Panel,
        "Vertical", // position header above the subgraph
        { defaultAlignment: go.Spot.Left },
        $(
          go.Panel,
          "Horizontal", // the header
          { defaultAlignment: go.Spot.Top, padding: new go.Margin(10, 10) },
          $("SubGraphExpanderButton"), // this Panel acts as a Button
          $(
            go.TextBlock, // group title near top, next to button
            {
              font: "Bold 11pt Sans-Serif",
              editable: false,
              stroke: "white",
              margin: new go.Margin(2, 3, 0, 8),
              // textEdited: this.editGroupTitle,
            },
            new go.Binding("text", "groupLabel")
          ),
          $(
            go.TextBlock,
            {
              font: "Bold 10pt Sans-Serif",
              editable: true,
              stroke: "white",
              margin: new go.Margin(2, 0, 0, 0),
            },
            new go.Binding("text", "", (node) => {
              return node &&
                (node.pageNodesCount ||
                  node.sceneNodesCount ||
                  node.logicNodesCount)
                ? " + ("
                : "";
            }),
            new go.Binding("visible", "", (node) => {
              return node &&
                (node.pageNodesCount ||
                  node.sceneNodesCount ||
                  node.logicNodesCount)
                ? true
                : false;
            })
          ),
          $(
            go.TextBlock,
            {
              font: "Bold 10pt Sans-Serif",
              editable: false,
              stroke: "white",
              margin: new go.Margin(2, 3, 0, 3),
              visible: false,
            },
            new go.Binding("text", "pageNodesCount"),
            new go.Binding("visible", "pageNodesCount", (pageNodesCount) => {
              return pageNodesCount ? true : false;
            })
          ),
          $(
            go.Shape,
            {
              name: "SHAPE",
              cursor: "pointer",
              portId: "",
              width: 18,
              height: 18,
              fromSpot: go.Spot.AllSides,
              fromLinkable: false,
              fromLinkableDuplicates: false,
              fromLinkableSelfNode: false,
              toSpot: go.Spot.AllSides,
              toLinkable: false,
              toLinkableDuplicates: false,
              toLinkableSelfNode: false,
              fill: "#161E32",
              // margin: 4,
              strokeWidth: 0.5,
              visible: false,
              margin: new go.Margin(-3, 0, 0, 0),
            },
            new go.Binding("fill", "pageNodeCategory", this.getNodeColor),
            new go.Binding("geometry", "pageNodeCategory", this.getNodeShape),
            new go.Binding(
              "visible",
              "pageNodeCategory",
              (pageNodeCategory) => {
                return pageNodeCategory ? true : false;
              }
            )
          ),
          
          $(
            go.TextBlock,
            {
              font: "Bold 10pt Sans-Serif",
              editable: true,
              stroke: "white",
              margin: new go.Margin(2, 3, 0, 5),
              visible: false,
            },
            new go.Binding("text", "", (node) => {
              return node &&
                node.pageNodesCount &&
                (node.sceneNodesCount || node.logicNodesCount)
                ? "+"
                : "";
            }),
            new go.Binding("visible", "", (node) => {
              return node &&
                node.pageNodesCount &&
                (node.sceneNodesCount || node.logicNodesCount)
                ? true
                : false;
            })
          ),
          $(
            go.TextBlock,
            {
              font: "Bold 10pt Sans-Serif",
              editable: true,
              stroke: "white",
              margin: new go.Margin(2, 3, 0, 5),
              visible: false,
            },
            new go.Binding("text", "sceneNodesCount"),
            new go.Binding("visible", "sceneNodesCount", (sceneNodesCount) => {
              return sceneNodesCount ? true : false;
            })
          ),
          $(
            go.Shape,
            {
              name: "SHAPE",
              cursor: "pointer",
              portId: "",
              width: 18,
              height: 18,
              fromSpot: go.Spot.AllSides,
              fromLinkable: false,
              fromLinkableDuplicates: false,
              fromLinkableSelfNode: false,
              toSpot: go.Spot.AllSides,
              toLinkable: false,
              toLinkableDuplicates: false,
              toLinkableSelfNode: false,
              fill: "#161E32",
              // margin: 4,
              strokeWidth: 0.5,
              visible: false,
              margin: new go.Margin(-3, 0, 0, 0),
            },
            new go.Binding("fill", "sceneNodeCategory", this.getNodeColor),
            new go.Binding("geometry", "sceneNodeCategory", this.getNodeShape),
            new go.Binding(
              "visible",
              "sceneNodeCategory",
              (sceneNodeCategory) => {
                return sceneNodeCategory ? true : false;
              }
            )
          ),
          $(
            go.TextBlock,
            {
              font: "Bold 10pt Sans-Serif",
              editable: true,
              stroke: "white",
              margin: new go.Margin(2, 3, 0, 5),
              visible: false,
            },
            new go.Binding("text", "", (node) => {
              return node &&
                node.pageNodesCount &&
                node.sceneNodesCount &&
                node.logicNodesCount
                ? "+"
                : "";
            }),
            new go.Binding("visible", "", (node) => {
              return node &&
                node.pageNodesCount &&
                node.sceneNodesCount &&
                node.logicNodesCount
                ? true
                : false;
            })
          ),
          $(
            go.TextBlock,
            {
              font: "Bold 10pt Sans-Serif",
              editable: true,
              stroke: "white",
              margin: new go.Margin(2, 3, 0, 3),
              visible: false,
            },
            new go.Binding("text", "logicNodesCount"),
            new go.Binding("visible", "logicNodesCount", (logicNodesCount) => {
              return logicNodesCount ? true : false;
            })
          ),
          $(
            go.Shape,
            {
              name: "SHAPE",
              cursor: "pointer",
              portId: "",
              width: 18,
              height: 18,
              fromSpot: go.Spot.AllSides,
              fromLinkable: false,
              fromLinkableDuplicates: false,
              fromLinkableSelfNode: false,
              toSpot: go.Spot.AllSides,
              toLinkable: false,
              toLinkableDuplicates: false,
              toLinkableSelfNode: false,
              fill: "#161E32",
              // margin: 4,
              strokeWidth: 0.3,
              margin: new go.Margin(-3, 0, 0, 0),
              visible: false,
            },
            new go.Binding("fill", "logicNodeCategory", this.getNodeColor),
            new go.Binding("geometry", "logicNodeCategory", this.getNodeShape),
            new go.Binding(
              "visible",
              "logicNodeCategory",
              (logicNodeCategory) => {
                return logicNodeCategory ? true : false;
              }
            )
          ),
          $(
            go.TextBlock, // group title near top, next to button
            {
              font: "Bold 10pt Sans-Serif",
              editable: true,
              stroke: "white",
              margin: new go.Margin(2, 3, 0, 3),
              text: " )",
            },
            new go.Binding("text", "", (node) => {
              return node &&
                (node.pageNodesCount ||
                  node.sceneNodesCount ||
                  node.logicNodesCount)
                ? " )"
                : "";
            }),
            new go.Binding("visible", "", (node) => {
              return node &&
                (node.pageNodesCount ||
                  node.sceneNodesCount ||
                  node.logicNodesCount)
                ? true
                : false;
            })
          )
        ),
        $(
          go.Placeholder, // represents area for all member parts
          {
            padding: new go.Margin(10, 10),
            background: "#161E32",
            padding: 20,
            alignment: go.Spot.TopLeft,
          }
        )
      )
    );
    diagram.layout = $(go.LayeredDigraphLayout, {
      layerSpacing: 20,
      isRealtime: false,
    });
    diagram.linkTemplate = $(
      go.Link,
      { routing: go.Link.AvoidsNodes },
      $(go.Shape, { strokeWidth: 2, stroke:  'white'   }),
      $(go.Shape, { toArrow: "OpenTriangle" }),
      $(go.TextBlock,
       { font: '12pt FontAwesome' ,segmentOffset: new go.Point(0, 10),stroke:'white'},
        new go.Binding("text", "from",
         (node) => {
           let count = 0
            this.wrongNodes.forEach(element => {
             if( element.key ===node) count+=1
            })
           return count > 0  ? "\uf071" : "";
            }
        ),
        ),
    );
    this.diagram = diagram;
    this.updateModel(this.modelData);
    this.diagram.addDiagramListener("ObjectDoubleClicked", (e) => {
      const part = e.subject.part;
      if (!(part instanceof go.Link)) this.showData(part.data);
    });
    this.diagram.addDiagramListener("SelectionDeleted", (e) => {
      const part = e.subject.part;
      if (!(part instanceof go.Link)) this.saveTreeToDB();
    });
    this.diagram.addDiagramListener("ChangedSelection", (e) => {
     this.diagram.commandHandler.doKeyDown = function() {
          var e = this.diagram.lastInput;
          var control = e.control || e.meta;
          var key = e.key;
          if (control && (key === 'X' )) return;
      };
      this.selectedNodeKey=[]
      e.diagram.selection.each(element => {
        if(element.key){
                this.selectedNodeKey.push(element.key)
        }
      });
      const node = e.diagram.selection.first();
      if (node) {
        const cmdhnd = this.diagram.commandHandler;
        this.deleteButtonIsActive = cmdhnd.canDeleteSelection();
      } else {
        this.deleteButtonIsActive = false;
      }
    });
    this.diagram.addModelChangedListener((e) => {
      if (e.isTransactionFinished) {
        const cmdhnd = this.diagram.commandHandler;
        this.undoButtonIsActive = cmdhnd.canUndo();
        this.redoButtonIsActive = cmdhnd.canRedo();
        this.deleteButtonIsActive = cmdhnd.canDeleteSelection();
      }
    });
   // this.diagram.select(this.diagram.findNodeForKey(0))
    //console.log(this.diagram.findNodeForKey(0))
  },
  watch: {
    modelData() {
      this.updateModel(this.modelData);
    },
  },
  computed: {
    storyID() {
      return localStorage.getItem("storyId");
    },
  },
};
</script>

<style scoped lang="scss">
/* only wrote css for specific target */
@import "../../external_libs/frame.js/editor/css/dark.css";
@import "../../external_libs/frame.js/editor/css/main.css";

bode {
  background-color: #212529;
}

ul {
  text-decoration: none;
  list-style: none;
}

.edit-story-wrapper {
    min-height: auto;
}

.navigation-bar {
  width: 100%;
  background-color: #222323;
  padding: 12px 15px;
  color: #fff;
  border-bottom: solid 1px #777;
  z-index: 9;
  max-height: 64px;
}

.main_container {
  display: flex;
  width: 100%;
  height: auto;
  background-color: #212529;
}

#myDiagramDiv {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #161E32;
}

.edit-story-wrapper {
  background-color: #212529;
  color: #e7e7e7;
  padding: 0px;
  position: relative;
  margin-top: 0px;
}

.container-fluid {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #212529;
  // padding-right: 15px;
  padding: 0;
  margin: 0;
  height: calc(100vh - 64px);
  // padding-left: 15px;
  // margin-right: auto;
  // margin-left: auto;
}

.toggle-sidebar {
  position: absolute;
}

.controls-sidebar {
  position: fixed;
  right: 25px;
  top: 15%;
  transform: translate(0, 0%);
  padding: 30px 5px;
  margin-right: 30px;
  margin-left: 0px;
  background-color: #283046eb;
  //border: 1px solid #4A8F8A;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;
  transition: .3s all ease-in-out;
  

  .toggle-sidebar {
    position: fixed;
    //border: 3px solid #4A8F8A;
    //background-color: #161E32;
    display: grid;
    align-content: center;
    bottom: -70px;
    left: 50%;
    padding: 5px;
    border-radius: 15px 0 0 15px;
    transform: translate(-50%, 0) rotate(-90deg);
    height: 100px;
    cursor: pointer;
    transition: .3s all ease-in-out;

    &:hover {
      background-color: #262626;
    }

    svg {
      transition: .4s all ease;
      transform: rotate(180deg);
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }

  li {
    border-radius: 10px;
    padding: 3px 0 0 0;
    margin: 10px 5px;
    cursor: pointer;
    transition: .3s all ease-in-out;

    span {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      
      img {
        margin-bottom: 5px;
      }
    }
  }

  li:hover {
    background-color: #262626;
  }
  li:last-child {
    text-decoration: line-through;
  }
}

@media  (max-width: 1024px) {
  .controls-sidebar {
  top: 80vh;
  right: -25%;
  width: 100%;
  transform: translateX(-25%);
  padding: 5px 30px;
  margin: 0px 30px 0 30px;
  border-radius: 10px;
  flex-direction: row;
  z-index: 1000;

    li, a {
      margin: 5px 10px;
    }
  }
  
}

.controls-topbar {
  position: absolute;
  right: 50vw;
  transform: translateX(50%);
  top: 20px;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
  padding: 0;
  // margin-right: 50px;

  li, a {
  background-color: #283046;
  border-radius: 10px;
  padding: 2px;
  margin: 0 5px;
  cursor: pointer;
  transition: .3s all ease-in-out;

  }
  li:hover, a:hover {
    background-color: #303030;
  }
}

@media screen and (max-width: 1024px) {
ol, ul, dl {
margin-top: 0;
margin-bottom: 0rem;
}
.controls-sidebar {
    top: auto;
    bottom: 0;
    right: -50%;
    width: 100%;
    -webkit-transform: translate(-25%, 0);
    transform: translate(-50%, 0);
    padding: 5px 5px;
    margin: 0px 0 0 64px;
    border-radius: 10px;
    z-index: 999;

    .toggle-sidebar {
      bottom: auto;
      right: auto;
      left: 50%;
      top: -68px;
      padding-right: 0;
      transform: translate(0%, -50%);
      transform: rotate(90deg);
    }

    ul {
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      justify-content: space-between;
      flex-direction: row;
    }

    li, a {
      margin: 3px 3px;
      padding: 0px;
      font-size: .9rem;

      svg {
        widows: 24px;
        height: 24px;
      }
    }
    
  }

  .controls-topbar {
  li, a {
  background-color: #262626;
  border-radius: 10px;
  padding: 1px;
  margin: 0 10px;
  cursor: pointer;
  transition: .3s all ease-in-out;

    svg {
        widows: 14px;
        height: 14px;
    }
    .play {
      i {
        color: #018aff;
      }
    }
    
  }
}
  .nav-link {
    display: block;
    padding: 0.5rem 1rem;
  } 
  
}



@media screen and (max-width: 820px) {
  .controls-sidebar {
    margin: 0px;
    left: 50%;
    width: 95%;
    top: auto;
    bottom: 68px;
    z-index: 900;
    ul {
      justify-content: space-evenly;
    }
    li {
      font-size: 0rem;
    }
  }
}
.coming_soon{
  background-color: #283046!important;
  cursor:initial!important;
}
</style>



// WEBPACK FOOTER //
// src/views/mainStoryView.vue